<template>
  <v-row
    class="py-0 my-0"
  >
    <v-col
      cols="12"
      class="px-4"
      style="position: relative"
    >
      <div style="position: absolute; top: -10px;left: 0; right: 0; text-align: center">
        <span>{{ label }}</span>
      </div>
      <v-range-slider
        v-model="range"
        :max="max"
        :min="min"
        hide-details
        :disabled="disabled"
        class="align-center"
        @change="onValueChanged"
      >
        <template v-slot:prepend>
          <v-text-field
            :value="range[0]"
            class="mt-0 pt-0"
            hide-details
            single-line
            :disabled="disabled"
            type="number"
            style="width: 60px"
            @change="onInputValueChange(range, 0, $event)"
          />
        </template>
        <template v-slot:append>
          <v-text-field
            :value="range[1]"
            class="mt-0 pt-0"
            hide-details
            single-line
            :disabled="disabled"
            type="number"
            style="width: 60px"
            @change="onInputValueChange(range, 1, $event)"
          />
        </template>
      </v-range-slider>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'BaseNumberRange',
  components: {
  },
  props: {
    label: {
      type: String
    },
    resetEvent: {
      type: String
    },
    onChangeEvent: {
      type: String
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    valueMin: {
      type: Number,
    },
    valueMax: {
      type: Number,
    },
    disabled: {
      type: Boolean
    },
  },
  data: () => ({
    range: [null, null],
  }),
  computed: {
  },
  async  created () {
    this.range = [this.valueMin, this.valueMax]
  },
  methods: {
    onInputValueChange (range, index, value) {
      this.$set(range, index, parseInt(value, 10))
      this.$emit(this.onChangeEvent, this.range)
    },
    onInputMaxEvent (val) {
      this.valueMax = val
      this.$emit(this.onChangeEvent, [this.valueMin, this.valueMax])
    },
    onInputMinEvent (val) {
      this.valueMin = val
      this.$emit(this.onChangeEvent, [this.valueMin, this.valueMax])
    },
    onValueChanged (val) {
      this.$emit(this.onChangeEvent, val)
    },
    onClear () {
      this.range = [null, null]
    }
  }
}
</script>

